import Vue from 'vue'

const buildDatazapClickedEvent = (data) => ({
  datazap: {
    ...data,
  },
  event: 'datazapClicked',
})

const datazapClicked = (data) => {
  const event = buildDatazapClickedEvent({ ...data })
  Vue.$clickstream.trackEvent(event)
}

export default {
  datazapClicked,
  buildDatazapClickedEvent,
}
